module.exports = "<div class=\"cover-wrapper \" >\n  <div class=\"view cover z-depth-3\">\n      <img src=\"{{channel?.coverUrl}}\" class=\"img-fluid\" alt=\"\">\n  </div>\n  <div class=\"view hm-zoom user\">\n    <a [routerLink]=\"['/channel', _id ]\">\n      <img src=\"{{channel?.thumbnailUrl}}\" class=\"img-fluid z-depth-3\" alt=\"\">\n    </a>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/channel-cover/channel-cover.component.html
// module id = ./src/app/channel-cover/channel-cover.component.html
// module chunks = main